import QueryBookingCapacity from 'graphql/queries/QueryBookingCapacity'
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'

const FetchBookingCapacity = {
	
	fetchAllRange: ( { dates = [], kinds = null, subKinds = null, employeeGuid = '::employee_guid', callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		GraphqlGroupedBuilder.addQuery( 'booking_capacity', QueryBookingCapacity, {
			variables: {
				dates: dates,
				kinds: kinds,
				subKinds: subKinds,
				employeeGuid: employeeGuid
			},
			resultPath: [ 'booking_capacity' ],
			callbackStart,
			callbackError,
			callbackSuccess
		})
	}
}

export default FetchBookingCapacity
